// deps
import React, { ReactElement, useContext } from "react";

// internal-deps
import { RouteContext, RouteProps, ScreenTransition } from "@swiggy-private/core-ui";
import { RouteContextValue } from "@swiggy-private/core-ui";
import { DineoutCheckoutRoute } from "@swiggy-private/checkout-core";

export function DineoutCartMain(props: RouteProps<DineoutCheckoutRoute>): ReactElement {
    const { isForward } = useContext(RouteContext) as RouteContextValue<DineoutCheckoutRoute>;

    const children =
        Array.isArray(props.children) && props.children.length === 1 ? (
            <ScreenTransition forward={isForward}>{props.children[0]}</ScreenTransition>
        ) : (
            props.children
        );

    return <>{children}</>;
}
